import { useApolloClient } from '@apollo/client';
import { User, useUserQuery } from '../graphql/codegen/graphql-react';

const isValidUserId = (userId: string) => Boolean(userId && userId !== '-');

export const useUser = (userId: string) => {
  const apolloClient = useApolloClient();
  const {
    loading: userLoading,
    error: userError,
    data: userData,
    refetch: userRefetch,
    startPolling: userStartPolling,
    stopPolling: userStopPolling,
  } = useUserQuery({
    variables: { input: { userId } },
    skip: !isValidUserId(userId),
    // Refetch when switching user from the same route (query vars change); merge with cache after network.
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  const user: User = { ...((userData?.user || {}) as User) };

  const resetApolloCache = async () => {
    try {
      await apolloClient.cache.reset();
    } catch (error) {}
  };

  const evictUserIdCache = () => {
    const res = apolloClient.cache.evict({ id: `User:${userId}` });
    return res;
  };

  return {
    user,
    userLoading,
    userError,
    userRefetch,
    userStartPolling,
    userStopPolling,
    resetApolloCache,
    evictUserIdCache,
  };
};
